/**
 * Gaze Bridge — A React-free channel for high-frequency gaze data.
 *
 * The gaze tracker fires 60+ times/sec on mousemove. Routing that through
 * Zustand → React re-renders caused canvas flicker. This module provides a
 * direct ref-style bridge: the gaze tracker writes here, the canvas render
 * loop reads here. Zero React involvement on the hot path.
 */

import type { GazeState } from '@/types'

const defaultState: GazeState = {
  currentPoint: null,
  fixationLine: null,
  fixationParagraph: null,
  dwellStartTime: null,
  isFixating: false,
  velocity: 0,
}

/** Current gaze data — written by gaze tracker, read by render loop. */
let _current: GazeState = { ...defaultState }

export const gazeBridge = {
  /** Called by the gaze tracker on every point update. */
  update(state: GazeState) {
    _current = state
  },

  /** Read the latest gaze state (no copy — treat as read-only). */
  get(): GazeState {
    return _current
  },

  /** Reset to defaults (when tracking stops). */
  clear() {
    _current = { ...defaultState }
  },
}
